<template>
  <details-layout
    :back-btn="false"
    @close-drawer="$emit('close-drawer')"
  >
    <template #header>
      Your quote summary
    </template>
    <template #sub-header>
      Here's the details you've given us about you, your {{ productLabel }} and what you require from your
      insurance policy.
    </template>

    <template
      #additional-content
    >
      <details-list
        v-for="(data, key) in quoteSummary"
        :key="key"
        :list="data"
        :summary-section-title="key"
        :form-step-labels="formStepLabels"
        class="light"
        @go-to-form="$emit('go-to-form', $event)"
      />

      <change-quote-info
        class="px-6 py-8"
        @go-to-form="$emit('go-to-form')"
      />
    </template>
  </details-layout>
</template>

<script>
import DetailsList from '@/components/car/Results/DetailsList.vue';
import DetailsLayout from '@/components/car/Results/detailsDrawer/DetailsLayout.vue';
import ChangeQuoteInfo from '@/components/car/Results/ChangeQuoteInfo.vue';

export default {
  name: 'quote-summary',
  components: { ChangeQuoteInfo, DetailsLayout, DetailsList },
  inject: ['productName'],
  props: {
    quoteSummary: {
      type: Object,
      required: true,
    },
    formStepLabels: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    productLabel () {
      if (this.productName === 'bicycle') return 'bicycle(s)';
      if (this.productName === 'pet') return 'pet(s)';

      return this.productName;
    },
  },
};
</script>
